// extracted by mini-css-extract-plugin
export default {"modalContent":"EULAModal__modalContent___H8YC7"};